import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  getEl,
  closest,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import { saveData, validateRequired, validateEmail } from "../../utils/forms";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";
import TermsMaui from "../partials/terms-maui";
import TermsCancun from "../partials/terms-cancun";
import TermsCancun2020 from "../partials/terms-cancun2020";
import TermsMaui2019 from "../partials/terms-maui2019";
import TermsMaui2021 from "../partials/terms-maui2021";
import TermsMaui2021V2 from "../partials/terms-maui2021-v2";
import TermsKauai2019 from "../partials/terms-kauai2019";
import TermsKauai2021 from "../partials/terms-kauai2021";

const { siteMetadata: config } = GatsbyConfig;

export default class CheckoutPage extends React.Component {
  static BLANK_FORM_DATA = {
    referralSource: "",
  };

  componentDidMount() {
    const { trip } = this.props;
    const tripData = config.trips[trip];

    if (tripData.soldOut) return;
    this.validateDataKeys = Object.keys(CheckoutPage.BLANK_FORM_DATA);
    this.liveChecking = false;
    this.toggleExplanation(getEl(".with-explanation select"));
    setTimeout(this.setSubmitDisabled);
    setTimeout(window.scrollTo, 150, 0, 0);
  }

  saveAndNext(e) {
    e.preventDefault();
    this.data = saveData("lsg.book-data");
    if (
      validateRequired("lsg.book-data", this.validateDataKeys) &&
      validateEmail("lsg.book-data", ["email"])
    ) {
      const promo = getParamFromQueryString("promo", window.location.href);

      location.href = `/${this.data.trip}/pay/${
        promo ? `?promo=${promo}` : ""
      }`;
    } else {
      this.liveChecking = true;
    }
  }

  onInputChange() {
    this.data = saveData("lsg.book-data");
    this.setSubmitDisabled();
    if (this.liveChecking) {
      validateRequired("lsg.book-data", this.validateDataKeys);
      validateEmail("lsg.book-data", ["email"]);
    }
  }

  onSelectChange(e) {
    const selectEl = e.target;

    this.toggleExplanation(selectEl);
    selectEl.parentNode.classList.add("has-value");
    this.data = saveData("lsg.book-data");
    if (this.liveChecking) {
      validateRequired("lsg.book-data", this.validateDataKeys);
      validateEmail("lsg.book-data", ["email"]);
    }
  }

  toggleExplanation(selectEl) {
    const wrapperEl = closest(selectEl, ".with-explanation");
    const selectedOptionEl = selectEl.options[selectEl.selectedIndex];
    const doesExpand = !!selectedOptionEl.getAttribute("data-explain");

    wrapperEl.classList.toggle("expand", doesExpand);
    if (!doesExpand) {
      wrapperEl.querySelector(".explanation input").value = "";
    }
  }

  setSubmitDisabled() {
    const form = getEl("form");
    const formData = new FormData(form);
    const button = form.querySelector(".btn-primary");

    if (!!form.querySelector("input:checked")) {
      button.removeAttribute("disabled");
    } else {
      button.setAttribute("disabled", true);
    }
  }

  render() {
    if (typeof window === "undefined") return <main />;
    let data = { ...CheckoutPage.BLANK_FORM_DATA };
    try {
      data = JSON.parse(localStorage.getItem("lsg.book-data"));
    } catch (err) {}
    this.data = data;
    const { trip } = this.props;
    const tripData = config.trips[trip] || {};
    const termsVersion = tripData.termsVersion || "";
    const promo = getParamFromQueryString("promo", window.location.href);
    const title = `Checkout | ${tripData.name} ${tripData.year}`;
    const description =
      "Select your room type and payment option (monthly payment plan or" +
      "pay-in-full) to finalize your reservation on the Love Song Couples" +
      `Getaway | ${tripData.name} ${tripData.year}`;

    if (!data.room) {
      window.location.href = `/${trip}/prices`;
      return <main />;
    }
    return (
      <div className={`page-checkout trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader
          trip={trip}
          step="4"
          lock
          lockLogo={promo === "onlocation"}
        />
        {tripData.soldOut ? (
          <main>
            <p className="soldout-notice">Trip Sold Out</p>
          </main>
        ) : (
          <main className="form">
            <form className="wrap" onSubmit={(e) => e.preventDefault()}>
              <div className="content">
                <h2>How did you hear about us?</h2>
                <div className="with-explanation">
                  <p className="field">
                    <span
                      className={
                        data.referralSource ? "has-value select" : "select"
                      }
                    >
                      <select
                        name="referralSource"
                        defaultValue={data.referralSource}
                        onChange={this.onSelectChange.bind(this)}
                      >
                        <option value="" disabled selected>
                          Please choose one...
                        </option>
                        <option value="itickets.com">itickets.com</option>
                        <option value="csnradio.com">csnradio.com</option>
                        <option value="focusonthefamily.com">
                          focusonthefamily.com
                        </option>
                        <option value="Twitter">Twitter</option>
                        <option value="Facebook Ad">Facebook Ad</option>
                        <option value="Instagram">Instagram</option>
                        <option value="YouTube Ad">YouTube Ad</option>
                        <option value="Google Ad">Google Ad</option>
                        <option
                          data-explain
                          value="Artist or Speaker Website Banner (specific)"
                        >
                          Artist or Speaker Website Banner (specific)
                        </option>
                        <option value="E-mail">E-mail</option>
                        <option value="Brochure / Postcard">
                          Brochure / Postcard
                        </option>
                        <option data-explain value="Friend Referred Me">
                          Friend Referred Me
                        </option>
                        <option data-explain value="Other">
                          Other
                        </option>
                      </select>
                    </span>
                  </p>
                  <p className="field explanation">
                    <input
                      type="text"
                      autoComplete="off"
                      name="referralSourceExplanation"
                      placeholder="Please explain..."
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.referralSourceExplanation}
                    />
                  </p>
                </div>
                <h2 className="with-link">Everlasting Tours Agreement</h2>
                <div className="document">
                  <div className="pane">
                    {
                      {
                        maui: <TermsMaui hideExtras />,
                        cancun: <TermsCancun hideExtras />,
                        cancun2020: <TermsCancun2020 hideExtras />,
                        maui2019: <TermsMaui2019 hideExtras />,
                        kauai2019: <TermsKauai2019 hideExtras />,
                        kauai2021: <TermsKauai2021 hideExtras />,
                        maui2021: <TermsMaui2021 hideExtras />,
                        maui2021v2: <TermsMaui2021V2 hideExtras />,
                      }[`${trip}${termsVersion}`]
                    }
                  </div>
                </div>
                <p className="field">
                  <span className="checkbox">
                    <input
                      autoComplete="off"
                      type="hidden"
                      name="agreementChecked"
                      value="0"
                    />
                    <input
                      autoComplete="off"
                      id="agreementChecked"
                      type="checkbox"
                      name="agreementChecked"
                      onChange={this.onInputChange.bind(this)}
                    />
                    <label htmlFor="agreementChecked">
                      <i className="fa fa-check" />
                    </label>
                    I agree to the Everlasting Tours Agreement
                  </span>
                </p>
                <p className="button-bar full">
                  <button
                    className="btn-primary"
                    onClick={(e) => this.saveAndNext(e)}
                  >
                    Continue
                  </button>
                  <dfn>
                    * Check to agree to the Everlasting Tours Agreement before
                    continuing
                  </dfn>
                </p>
              </div>
            </form>
          </main>
        )}
        <SiteFooter trip={trip} hideTrips hideNewsletter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/checkout.js